'use strict';

import vendorConsents from './vendor-consents.js';
import logger from './logger.js';

function createScriptElement() {
    const script = document.createElement('script');
	script.setAttribute('data-wid', 'auto');
    script.type = 'text/javascript';
    script.src = 'https://content.viralize.tv/display/?zid=AAFkvAwTAGs2GGRx';
    return script;
}

function insertScriptAfterElement(element, script) {
	$(element).after(script);
}

function injectShowHeroesAds(block, element='', modifier='') {
	let firstParagraph = $.findByBem(block,element,modifier).children('p').first();
	if (firstParagraph.length > 0) {
		const script = createScriptElement();
		insertScriptAfterElement(firstParagraph, script);
	}
}

export default {
	init: (block, element='', modifier='') => {
		vendorConsents.addTcfApiHandler(vendorConsents.eventNames.userActionComplete, function () {
			vendorConsents.onRetrieveVendorAndPurposeConsents(() => {
				injectShowHeroesAds(block, element, modifier)
			}, () => {
				logger.info('Did not initialise inject show heroes ads script on completed user action: Insufficient consent');
			});
		});

		vendorConsents.addTcfApiHandler(vendorConsents.eventNames.subsequentPageLoad, function () {
			vendorConsents.onRetrieveVendorAndPurposeConsents(() => {
				injectShowHeroesAds(block, element, modifier)
			}, () => {
				logger.info('Did not initialise inject show heroes ads script on completed user action: Insufficient consent');
			});
		});
	},
}